import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './auth/AuthContext';
import { installAuthGuard } from './auth/authGuard';
import { installBugLog } from './utils/bugLog';

// Recover cleanly from an expired AAD session (SWA 302→identity host that XHR
// can't follow). Install before anything fetches. See auth/authGuard.js.
installAuthGuard();

// Capture console output + window errors from first paint, so a bug report can
// attach recent logs/events (see components/BugReporter.jsx).
installBugLog();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
